<template>
	<v-app-bar clipped-left app prominent >
		<img class="logo" src="http://www.workersrights.org/wp-content/uploads/2019/01/nav-logo.png" />
		<!-- <v-toolbar-title>Factory Disclosure Search</v-toolbar-title> -->
		<v-spacer></v-spacer>
		<!-- <v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn icon href="https://workersrights.org/" v-on="on">
					<v-icon>mdi-help</v-icon>
				</v-btn>
			</template>
			<span>Help</span>
		</v-tooltip> -->
		<TermsAndConditions />
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-btn icon href="https://workersrights.org/" v-on="on">
					<v-icon>mdi-home</v-icon>
				</v-btn>
			</template>
			<span>WorkersRights.org</span>
		</v-tooltip>

	</v-app-bar>
</template>
<script>
import TermsAndConditions from './TermsAndConditions';

export default {
	components: {
		TermsAndConditions
	}
}
</script>
<style scoped>
img.logo {
	max-height: 3em;
	margin-right: 2em;
	margin-top: 1em;
}
</style>
